export const COMMON_REQUIRED_ERROR = "This field is required.";
export const MIN_NAME_LENGTH = 3;
export const MAX_NAME_LENGTH = 50;
export const NAME_MIN_LENGTH_ERROR =
  "The name must be at least {0} characters.";
export const NAME_MAX_LENGTH_ERROR =
  "The name must be no more than {0} characters.";
export const MIN_MESSAGE_LENGTH = 3;
export const MAX_MESSAGE_LENGTH = 240;
export const MESSAGE_MIN_LENGTH_ERROR =
  "The message must be at least {0} characters.";
export const MESSAGE_MAX_LENGTH_ERROR =
  "The message must be no more than {0} characters.";
export const EMAIL_ERROR = "It’s not email format";
export const PHONE_ERROR = "Phone number isn’t correct";
export const MIN_PHONE_LENGTH = 10;
export const MAX_PHONE_LENGTH = 14;
export const PHONE_MIN_LENGTH_ERROR = "The phone must be at least {0} numbers.";
export const PHONE_MAX_LENGTH_ERROR =
  "The phone must be no more than {0} numbers.";
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 100;
export const PASSWORD_MIN_LENGTH_ERROR =
  "The password must be at least {0} characters long.";
export const PASSWORD_MAX_LENGTH_ERROR =
  "The password must be at max {0} characters long.";
export const PASSWORD_TIP = "Passwords must have at least one digit.";
export const PASSWORD_TIP_NOT_WHITESPACE = "Passwords must not contain spaces.";
export const FIELD_PASSWORD_LOWERCASE_AND_UPPERCASE_TIP =
  "Tip: include uppercase and lowercase characters.";
export const FIELD_PASSWORD_SPECIAL_SYMBOLS_TIP =
  "Tip: include special character.";
export const FIELD_PASSWORD_NO_MATCH_ERROR = "Password doesn`t match";
export const LOWERCASE_AND_UPPERCASE_REGEX = /(?=.*[a-z])(?=.*[A-Z])/;
export const SPECIAL_SYMBOLS_REGEX = /(?=.*[@$!%*#?&])/;
export const WHITESPACE_REGEX = /^\S+$/;
export const CONSENT_REQUIRED_ERROR = "You must agree to proceed";
export const ZIP_CODE_ERROR = "Zip code must be 5 digits";
